import applicationConstants from '~/libs/constants/application-constants.js'

export default defineNuxtPlugin(async ({ $pinia }) => {
    return {
        provide: {
            applicationConstants: applicationConstants
        }
    }
})
